import React from "react";
import { createRoot } from "react-dom/client";
import GenrePopUp from "./GenrePopUp";

if (document.getElementById("sifa-pop-up-genre")) {
    const root = createRoot(document.getElementById("sifa-pop-up-genre"));
    const apiEndpoint = JSON.parse(document.getElementById("sifa-pop-up-genre").dataset.api);
    const date_base_url = JSON.parse(document.getElementById("sifa-pop-up-genre").dataset.url);
    root.render(<GenrePopUp apiEndpoint={apiEndpoint}  dateBaseURL={date_base_url} />);
}

if (document.getElementById("genre-pop-up-footer")) {
    const root = createRoot(document.getElementById("genre-pop-up-footer"));
    const genreList = JSON.parse(document.getElementById("genre-pop-up-footer").dataset.genre);
    root.render(<GenrePopUp genreList={genreList} />);
}
